export const datetimepickerTimepickerDirective = ($translate, $mdLiveAnnouncer): ng.IDirective => {
	return {
		restrict: 'EA',
		require: 'ngModel',
		templateUrl: 'datetimepicker/datetimepicker-timepicker.directive.html',
		replace: false,
		controller () {
			const controller = this as {
				date: Date | null;
				handleMeridianSelection: (meridian: string | null) => void;
				changed: () => void;
			};
			let previousMeridian = getMeridian(controller.date);

			controller.handleMeridianSelection = (currentMeridian: string | null) => {
				if (currentMeridian == null) {
					previousMeridian = null;
					return;
				}

				if (previousMeridian !== currentMeridian) {
					$mdLiveAnnouncer.announce($translate.instant('datetimepicker_meridiem-selected', {
						meridian: currentMeridian
					}));
				}

				previousMeridian = currentMeridian;
			};
			controller.changed = () => {
				controller.handleMeridianSelection(getMeridian(controller.date));
			};
		},
		controllerAs: 'controller',
		scope: {
			date: '=ngModel',
			options: '=options'
		},
		bindToController: true,
		link (scope, element) {
			const controller = (scope as ng.IScope & {
				controller: {
					handleMeridianSelection: (meridian: string | null) => void;
				};
			}).controller;
			const onClick = (event: Event) => {
				const target = event.target as HTMLElement | null;
				if (target?.closest('.uib-time.am-pm button') == null) {
					return;
				}

				scope.$evalAsync(() => {
					const meridianButton = element[0].querySelector('.uib-time.am-pm button');
					const meridian = meridianButton?.textContent?.trim();
					controller.handleMeridianSelection(meridian == null || meridian === '' ? null : meridian);
				});
			};
			element.on('click', onClick);
			scope.$on('$destroy', () => {
				element.off('click', onClick);
			});
		}
	};
};

function getMeridian (date: Date | null): string | null {
	if (!(date instanceof Date) || isNaN(date.getTime())) {
		return null;
	}

	return date.getHours() >= 12 ? 'PM' : 'AM';
}

datetimepickerTimepickerDirective.$inject = ['$translate', '$mdLiveAnnouncer'];
